import React from "react";
import "./activity-indicator.scss";
import ActivityIndicatorIcon from "../../assets/loader.svg";
import { ActivityIndicatorProps } from "./activity-indicator.props";

const ActivityIndicator = (props: ActivityIndicatorProps) => {
  const getMainContainerStyle = () => {
    return {
      top: props.top ?? "0",
      bottom: props.bottom ?? "0",
      left: props.left ?? "0",
      right: props.right ?? "0",
      backgroundColor: props.opacity ? `rgba(5, 4, 33, ${props.opacity})` : "rgba(5, 4, 33, 0.49)"
    } as React.CSSProperties;
  };

  return (
    <div className="activity-indicator-container" data-testid="main-container" style={getMainContainerStyle()}>
      <div className="activity-indicator">
        <img src={ActivityIndicatorIcon} alt="load icon" width="46px" height="46px" />
        <span data-testid="loading" className="activity-indicator-text">
          Loading
        </span>
      </div>
    </div>
  );
};

export default ActivityIndicator;
